module.exports = __webpack_public_path__ + "static/media/qr-code-icon.8734d2be.svg";